import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_ScopeActionsAddCompany = _resolveComponent("ScopeActionsAddCompany")!
  const _component_ScopeActionsAddActivity = _resolveComponent("ScopeActionsAddActivity")!
  const _component_ScopeActionsAddTaxSystem = _resolveComponent("ScopeActionsAddTaxSystem")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "d-flex" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { class: "flex-grow-1 flex-shrink-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field_filled, {
            modelValue: _ctx.searchSync,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchSync) = $event)),
            label: "Rechercher",
            outlined: "",
            "hide-details": "",
            density: "compact",
            clearable: "",
            "append-inner-icon": "$search",
            "onClick:clear": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchSync = ''))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { class: "d-flex justify-end align-center flex-grow-0 flex-shrink-1" }, {
        default: _withCtx(() => [
          (!_ctx.hideCompany)
            ? (_openBlock(), _createBlock(_component_ScopeActionsAddCompany, {
                key: 0,
                companies: _ctx.clientsSync,
                "onUpdate:companies": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.clientsSync) = $event))
              }, null, 8, ["companies"]))
            : _createCommentVNode("", true),
          (!_ctx.hideActivity)
            ? (_openBlock(), _createBlock(_component_ScopeActionsAddActivity, {
                key: 1,
                activities: _ctx.activitiesSync,
                "onUpdate:activities": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activitiesSync) = $event))
              }, null, 8, ["activities"]))
            : _createCommentVNode("", true),
          (!_ctx.hideTaxSystem)
            ? (_openBlock(), _createBlock(_component_ScopeActionsAddTaxSystem, {
                key: 2,
                taxSystems: _ctx.taxSystemsSync,
                "onUpdate:taxSystems": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.taxSystemsSync) = $event))
              }, null, 8, ["taxSystems"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}